import type { ActivityEvent, EventType } from './domain';
import { deleteValue, getAll, putValue, setSetting, setting } from './db';

let flushing = false;

export async function getDeviceIdentity() {
  let deviceId = await setting('deviceId');
  if (!deviceId) { deviceId = crypto.randomUUID(); await setSetting('deviceId', deviceId); }
  let sessionId = sessionStorage.getItem('daily-session');
  if (!sessionId) { sessionId = crypto.randomUUID(); sessionStorage.setItem('daily-session', sessionId); }
  return { deviceId, sessionId };
}

export async function recordEvent(eventType: EventType, payload: Record<string, unknown>, branchId?: string) {
  const ids = await getDeviceIdentity();
  const event: ActivityEvent = {
    eventId: crypto.randomUUID(), ...ids, branchId, eventType,
    occurredAt: new Date().toISOString(), payload
  };
  await putValue('outbox', event);
  void flushOutbox();
  return event;
}

export async function flushOutbox() {
  if (flushing || !navigator.onLine) return false;
  flushing = true;
  try {
    const events = await getAll<ActivityEvent>('outbox');
    if (!events.length) return true;
    const response = await fetch('/api/sync', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ events: events.slice(0, 500) })
    });
    if (!response.ok) return false;
    const result = await response.json() as { acceptedEventIds?: string[] };
    await Promise.all((result.acceptedEventIds ?? []).map((id) => deleteValue('outbox', id)));
    await setSetting('lastSync', new Date().toISOString());
    return true;
  } catch {
    return false;
  } finally {
    flushing = false;
  }
}
